import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Resonance } from './components/Resonance';
import { Resonates } from './components/Resonates';
import { Opportunity } from './components/Opportunity';
import { Credibility } from './components/Credibility';
import { Partners } from './components/Partners';
import { Benefits } from './components/Benefits';
import { HowItWorks } from './components/HowItWorks';
import { Flexibility } from './components/Flexibility';
import { Conversemos } from './components/Conversemos';
import { LeadForm } from './components/LeadForm';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-ivory font-sans" data-id="element-0" data-mp="23vkuadim43jn">
      <Nav data-id="element-1" data-mp="23ut9zyugts8o" />
      <main data-id="element-2" data-mp="23t8heerpojdg">
        <Hero data-id="element-3" data-mp="23ti7018ugoim" />
        <Resonance data-id="element-4" data-mp="3ik7g4ghnibqn" />
        <Opportunity data-id="element-5" data-mp="3ikqyfyb7r257" />
        <Credibility data-id="element-6" data-mp="3ij61y35c994p" />
        <Partners data-id="element-7" data-mp="3ihv2gfixenje" />
        <Resonates data-id="element-8" data-mp="3mljaezbgzl56" />
        <Benefits data-id="element-9" data-mp="3ml12v6jcxkhy" />
        <HowItWorks data-id="element-10" data-mp="3mkho1yp07c85" />
        <Flexibility data-id="element-11" data-mp="3mjzpgvevclx2" />
        <Conversemos data-id="element-12" data-mp="3mj6hxs835sdv" />
        <LeadForm data-id="element-13" data-mp="3rcj846sey78q" />
        <Faq data-id="element-14" data-mp="3rbzq6q2rjiup" />
        <FinalCta data-id="element-15" data-mp="3rdkgg3i1ofmr" />
      </main>
      <Footer data-id="element-16" data-mp="3recctgjguhe3" />
    </div>;
}